import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nutritional-preview"
export default class extends Controller {
  static targets = ["textOutput", "textInput", "radioButton", "radioContainer", "currentScore", "emojiScore", "ratingIconsContainer", "maxRating"]

  connect() {
    this.calculateScore();
    this.displayScoreImagePreview();
  }

  previewOnTyping() {
    this.replaceText();
  }

  replaceText() {
    if (!!this.textInputTarget && !!this.textOutputTarget) {
      let input = this.textInputTarget.value;
      let output = this.textOutputTarget;

      output.innerHTML = this.simpleFormat(input);
    }
  }

  getCheckedRadios() {
    return this.radioButtonTargets.filter(radio => radio.checked);
  }

  calculateScore() {
    let radios = this.getCheckedRadios();
    let score = 0;

    radios.forEach(radio => {
      if (radio.value === "good") {
        score += 2;
      } else if(radio.value === "neutral") {
        score += 1;
      }
    });

    return score
  }

  setCurrentScore() {
    let score = this.calculateScore();

    this.setEmoji();
    this.displayScoreImagePreview();
    this.currentScoreTarget.innerHTML = score;
  }

  setEmoji() {
    let score = this.calculateScore();
    let emoji = this.emojiScoreTarget;
    const maxRating = parseInt(this.maxRatingTarget.innerHTML, 10)

    if (score < (maxRating / 3)) {
      emoji.innerHTML = `<img class="diary-weekly-overview__emoji" src="${this.badEmojiPath}" alt="Sad Emoji">`;
    } else if (score < (maxRating * 2) / 3) {
      emoji.innerHTML = `<img class="diary-weekly-overview__emoji" src="${this.neutralEmojiPath}" alt="Neutral Emoji">`;
    } else {
      emoji.innerHTML = `<img class="diary-weekly-overview__emoji" src="${this.happyEmojiPath}" alt="Happy Emoji">`;
    }
  }

  displayScoreImagePreview() {
    const radios = this.getCheckedRadios();

    radios.forEach(radio => {
      const radioParentContainer = this.findRadioParent(radio);
      const image = this.findImageInContainer(radioParentContainer)
      const imageClone = image.cloneNode(true)
      const categoryName = radio.getAttribute('data-category-name');

      const previewCategory = document.querySelector(`[data-preview-category-name="${categoryName}"]`);
      previewCategory.innerHTML = "";
      previewCategory.append(imageClone);
    });
  }

  // Helper methods
  simpleFormat(str) {
    return str.split('\n\n').map(paragraph => `<p>${paragraph.replace(/\n/g, '<br>')}</p>`).join('');
  }

  findImageInContainer(container) {
    return container.querySelector('img');
  }

  findRadioParent(radio) {
    return radio.closest('.rating-options');
  }

  get badEmojiPath() {
    return this.data.get("badEmojiPath");
  }

  get neutralEmojiPath() {
    return this.data.get("neutralEmojiPath");
  }

  get happyEmojiPath() {
    return this.data.get("happyEmojiPath");
  }
}
